import Container from "@/components/Container/Container";
import Button from "@/components/Button/Button";
import { site } from "@/content/site";
import styles from "./CTASection.module.css";

type CTASectionProps = {
  eyebrow?: string;
  title?: string;
  body?: string;
};

export default function CTASection({
  eyebrow = "Ready to begin?",
  title = "Therapy starts with a single conversation.",
  body = "Schedule a free 15-minute consultation, or verify your insurance benefits in minutes through Headway.",
}: CTASectionProps) {
  return (
    <section className={styles.cta}>
      <Container width="default" className={styles.inner}>
        <span className="eyebrow">{eyebrow}</span>
        <h2 className={styles.title}>{title}</h2>
        <p className={styles.body}>{body}</p>
        <div className={styles.actions}>
          <Button as="link" to="/contact" variant="primary" size="lg">
            Schedule a consultation
          </Button>
          <Button as="a" href={site.links.headway} variant="secondary" size="lg">
            Verify insurance via Headway
          </Button>
        </div>
      </Container>
    </section>
  );
}
